var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { jsonPost } from '@square/dashboard-utilities/utils/xhr';
import Service, { inject as service } from '@ember/service';
import { InstallationActionSource } from '@square/dashboard-protos/models/squareup/addons/data/installation_action_source';
import { ListAllAddonsRequest, ListAllAddonsResponse } from '@square/dashboard-protos/models/squareup/addons/external/list_all_addons';
import { GetAllAddonsRequest, GetAllAddonsResponse } from '@square/dashboard-protos/models/squareup/addons/external/get_all_addons';
import { GetAllAddonStatusForSellerRequest, GetAllAddonStatusForSellerResponse } from '@square/dashboard-protos/models/squareup/addons/external/get_all_addon_status_for_seller';
import { v4 as uuid } from 'uuid';
import { captureException } from '@sentry/ember';
import DeviceProfileError, { ADDON_INSTALL_ERROR, ADDON_UNINSTALL_ERROR, DeviceProfileMessage } from '@square/dashboard-data/models/device-profiles-v2/device-profile-error';
import { isEmpty } from '@ember/utils';
import { camelize, underscore } from '@square/dashboard-utilities/utils/keys';
import { InstallAddonRequest, InstallAddonResponse } from '@square/dashboard-protos/models/squareup/addons/external/install_addon';
import { UninstallAddonRequest, UninstallAddonResponse } from '@square/dashboard-protos/models/squareup/addons/external/uninstall_addon';
const ADDONS_V1_PREFIX = '/api/v1/addons';
const ADDONS_V2_PREFIX = '/api/v2/addons';
const ADDONS_GET_ALL_URL = `${ADDONS_V2_PREFIX}/get-all-addons`;
const ADDONS_GET_ALL_STATUS_URL = `${ADDONS_V2_PREFIX}/get-all-addon-status-for-seller`;
const ADDONS_LIST_URL = `${ADDONS_V1_PREFIX}/list_all_addons`;
const ADDONS_INSTALL_URL = `${ADDONS_V1_PREFIX}/install`;
const ADDONS_UNINSTALL_URL = `${ADDONS_V1_PREFIX}/uninstall`;
const IS_DPV2_ADDON_HEADER = 'Is-DPv2-Dashboard';
const ADDONS_REQUEST_HEADERS = {
  [IS_DPV2_ADDON_HEADER]: 'true'
};
let Addons = (_class = class Addons extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "userInfo", _descriptor, this);
  }
  async getAllAddons(supportedAddons = []) {
    const request = GetAllAddonsRequest.create({
      installedOnly: false
    });
    const json = underscore(request.toJSON());
    try {
      const response = await jsonPost(ADDONS_GET_ALL_URL, json, {
        headers: ADDONS_REQUEST_HEADERS
      });
      const proto = GetAllAddonsResponse.fromObject(camelize(response));
      const addons = proto.addon.filter(({
        addonId
      }) => isEmpty(supportedAddons) || supportedAddons.includes(addonId));
      return addons;
    } catch (err) {
      captureException(err);
      return [];
    }
  }
  async getAllAddonStatusForSeller(supportedAddons = []) {
    const request = GetAllAddonStatusForSellerRequest.create({
      installedOnly: false
    });
    const json = underscore(request.toJSON());
    try {
      const response = await jsonPost(ADDONS_GET_ALL_STATUS_URL, json, {
        headers: ADDONS_REQUEST_HEADERS
      });
      const proto = GetAllAddonStatusForSellerResponse.fromObject(camelize(response));
      const addonStatus = proto.statusForSeller.filter(({
        addonId
      }) => isEmpty(supportedAddons) || supportedAddons.includes(addonId));
      return addonStatus;
    } catch (err) {
      captureException(err);
      return [];
    }
  }
  getAddons(filteredAddons = []) {
    const listAddonsRequest = ListAllAddonsRequest.create({
      installedOnly: false
    });
    const json = underscore(listAddonsRequest.toJSON());
    return jsonPost(ADDONS_LIST_URL, json, {
      headers: ADDONS_REQUEST_HEADERS
    }).then(resp => {
      const proto = ListAllAddonsResponse.fromObject(camelize(resp));
      if (!proto.success) {
        // add error
        return [];
      }
      return proto.addon.filter(addon => isEmpty(filteredAddons) || filteredAddons.includes(addon.firstPartyAddon));
    }).catch(err => {
      captureException(err);
      return [];
    });
  }
  installAddon(firstPartyAddon) {
    const installRequest = InstallAddonRequest.create({
      firstPartyAddon,
      idempotenceKey: uuid(),
      shouldEnable: true,
      actingEmployeeToken: this.userInfo.employmentToken,
      actionSource: InstallationActionSource.DASHBOARD_ACTION,
      populateAddonInResponse: true
    });
    const json = underscore(installRequest.toJSON());
    return jsonPost(ADDONS_INSTALL_URL, json, {
      headers: ADDONS_REQUEST_HEADERS
    }).then(resp => {
      const proto = InstallAddonResponse.fromObject(camelize(resp));
      if (!proto.success) {
        throw new DeviceProfileMessage(proto.localizedErrorMessage, ADDON_INSTALL_ERROR);
      }
      return proto;
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError('Error installing addon', err, {
        status: ADDON_INSTALL_ERROR
      });
    });
  }
  uninstallAddon(firstPartyAddon) {
    const uninstallRequest = UninstallAddonRequest.create({
      firstPartyAddon,
      idempotenceKey: uuid(),
      shouldDisable: true,
      actingEmployeeToken: this.userInfo.employmentToken,
      actionSource: InstallationActionSource.DASHBOARD_ACTION,
      populateAddonInResponse: true
    });
    const json = underscore(uninstallRequest.toJSON());
    return jsonPost(ADDONS_UNINSTALL_URL, json, {
      headers: ADDONS_REQUEST_HEADERS
    }).then(resp => {
      const proto = UninstallAddonResponse.fromObject(camelize(resp));
      if (!proto.success) {
        throw new DeviceProfileMessage(proto.localizedErrorMessage, ADDON_INSTALL_ERROR);
      }
      return proto;
    }).catch(err => {
      captureException(err);
      throw new DeviceProfileError('Error uninstalling addon', err, {
        status: ADDON_UNINSTALL_ERROR
      });
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "userInfo", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Addons as default };